import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { AppRoutes } from './routes/router';

/**
 * Entry point — the old `src/index.js`.
 *
 * Not carried over from it:
 *  - `reportWebVitals()`, which was called with no argument and is therefore a no-op.
 *  - `react-icons` (FaMicrosoft / SiOkta) and `services/authProvider`, imported solely
 *    for the `ProviderSelector` screen that is entirely commented out (index.js:25-60,
 *    71-80). Dropping them removes the whole react-icons dependency.
 *
 * StrictMode is kept, as in the original. It double-invokes effects in development, so
 * anything that must run once is guarded explicitly (see AuthContext's bootstrappedRef).
 */
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>,
);
